{
    "(save {highestYearlyDiscount}%)": "(aurreztu %{highestYearlyDiscount})",
    "{amount} days free": "{amount} egun doan",
    "{amount} off": "{amount}(e)ko deskontua",
    "{amount} off for first {number} months.": "{amount}(e)ko deskontua lehenengo {number} hilabeteetan.",
    "{amount} off for first {period}.": "{amount}(e)ko deskontua lehenengo {period}(e)rako.",
    "{amount} off forever.": "{amount}(e)ko deskontua betiko",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "%{discount} merkeago",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail}(e)k ez du {newsletterName} buletin gehiagorik jasoko.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail}(e)k ez du ePosta gehiagorik jasoko norbaitek iruzkinei erantzuten dienean.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail}(e)k ez du buletin hau jasoko.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} egun debalde",
    "{years} years": "",
    "+1 (123) 456-7890": "+3X 123 456 789",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Kontua",
    "Account details updated successfully": "Kontuaren xehetasunak eguneratu dira",
    "Account settings": "Kontuaren ezarpenak",
    "Add a personal note": "Gehitu ohar pribatu bat",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Probaldia amaitutakoan, aukeratu duzun planaren ohiko prezioa kobratuko zaizu. Data iritsi baino lehen utzi dezakezu.",
    "Already a member?": "Kidea dagoeneko?",
    "An error occurred": "Errorea gertatu da",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ustekabeko errorea gertatu da. Saiatu berriro edo <a>jarri harremanetan</a> erroreak irauten badu.",
    "Back": "Atzera",
    "Back to Log in": "Itzuli saioa hastera",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Ostiral Beltza",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Utzi nahi duzunean.",
    "Cancel subscription": "Utzi harpidetza",
    "Canceled": "",
    "Cancellation reason": "Uztearen arrazoia",
    "Change": "Aldatu",
    "Change plan": "Aldatu plana",
    "Check spam & promotions folders": "Arakatu mezu baztergarrien eta promozioen karpetak",
    "Check with your mail provider": "Jarri harremanetan zure ePosta hornitzailearekin",
    "Check your inbox to verify email update": "Begiratu zure postontzia ePostaren eguneraketa egiaztatzeko",
    "Choose": "Aukeratu",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Aukeratu beste plan bat",
    "Choose a plan": "Aukeratu plan bat",
    "Choose a tier": "",
    "Choose your newsletters": "Aukeratu zure buletinak",
    "Click here to retry": "Klikatu hemen berriro saiatzeko",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Itxi",
    "Code": "",
    "Comment preferences updated.": "Iruzkinen hobespenak eguneratu dira.",
    "Comments": "Iruzkinak",
    "Complimentary": "Osagarria",
    "Confirm": "Baieztatu",
    "Confirm cancellation": "Baieztatu ezeztapena",
    "Confirm subscription": "Baieztatu harpidetza",
    "Contact support": "Jarri laguntza-taldearekin harremanetan",
    "Continue": "Jarraitu",
    "Continue subscription": "Jarraitu harpidetzarekin",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Ezin izan da Stripe ordainketa saioa sortu",
    "Could not sign in. Login link expired.": "Ezin izan da saioa hasi; esteka iraungi da.",
    "Could not update email! Invalid link.": "Ezin izan da ePosta eguneratu! Estekak ez du balio.",
    "Create a new contact": "Sortu kontaktu berria",
    "Current plan": "Uneko plana",
    "Delete account": "Ezabatu kontua",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Ez zenuen hori egin nahi? Kudeatu zure hobespenak <button>hemen</button>.",
    "Don't have an account?": "Ez duzu konturik?",
    "Edit": "Editatu",
    "Email": "ePosta",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "ePosta buletina",
    "Email newsletter settings updated": "ePosta buletinaren ezarpenak eguneratu dira",
    "Email preferences": "ePosta hobespenak",
    "Email preferences updated.": "ePosta hobespenak eguneratu dira",
    "Emails": "ePostak",
    "Emails disabled": "ePostak desgaituta",
    "Ends {offerEndDate}": "{offerEndDate}(e)an amaituko da",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Sartu zure ePosta helbidea",
    "Enter your name": "Sartu zure izena",
    "Error": "Errorea",
    "Expires {expiryDate}": "{expiryDate}(e)an iraungiko da",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Harpidetza ezeztatzeak huts egin du, saiatu berriro",
    "Failed to log in, please try again": "Saioa hasteak huts egin du, saiatu berriro",
    "Failed to log out, please try again": "Saioa amaitzeak huts egin du, saiatu berriro",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Ordainketak huts egin du, saiatu berriro",
    "Failed to send magic link email": "Esteka magikoa ePostaz bidaltzeak huts egin du",
    "Failed to send verification email": "Egiaztatze-esteka ePostaz bidaltzeak huts egin du",
    "Failed to sign up, please try again": "Izen-emateak huts egin du, saiatu berriro",
    "Failed to update account data": "Kontuaren datuen eguneraketak huts egin du",
    "Failed to update account details": "Kontuaren xehetasunen eguneraketak huts egin du",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Buletin-ezarpenen eguneraketak huts egin du",
    "Failed to update subscription, please try again": "Harpidetza eguneraketak huts egin du",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Betiko",
    "Free Trial – Ends {trialEnd}": "Probaldia - {trialEnd}(e)an amaituko da",
    "From": "",
    "Get help": "Eskuratu laguntza",
    "Get in touch for help": "Jarri harremanetan laguntza lortzeko",
    "Get notified when someone replies to your comment": "Jaso jakinarazpena norbaitek zure iruzkinari erantzuten dionean",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Eman argitalpen honi buruzko iritzia",
    "Help! I'm not receiving emails": "Lagundu! Ez dut ePostarik jasotzen",
    "Here are a few other sites you may enjoy.": "Hona hemen gogoko izan ditzakezun beste gune batzuk.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Buletin bat baztergarritzat jotzen bada, ePostak automatikoki desgaitzen dira helbide horretarako, berriro nahi ez duzun postarik jasoko ez duzula ziurtatzeko.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Mezu baztergarriatzat markatu izana nahi gabe izan bada, edo ePostak berriro jaso nahiko bazenitu, aurreko orrian ageri den botoia sakatu dezakezu berriro harpidetzeko.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Harpidetza gaur uzten baduzu, {periodEnd} arte izango duzu edukira sarbidea.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Enpresa- edo gobernu-posta baduzu, jar zaitez harremanetan IT sailarekin eta eska iezaiezu baimentzeko {senderEmail}(r)en mezuak jasotzea",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Saioa hasteko esteka bat bidali da zure postontzira. Hiru minututan ailegatzen ez bada, arakatu mezu baztergarrien karpeta.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "ePostak berriro jasotzen hasi nahi baduzu, egiaztatu fitxategian zure helbide elektronikoa edozein arazotarako, eta, ondoren, egin klik aurreko orriko botoian.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "ePostan harpidetu zaren buletina jaso ez baduzu, honakoak egiaztatu ditzakezu.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Egiaztaketa horiek guztiak egin badituzu eta, hala ere, mezurik jasotzen ez baduzu, {supportAddress} helbidera idatz dezakezu laguntza eskatzeko.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Buletina bidaltzen saiatzean hutsegite konponezina gertatzen bada bada, mezu elektronikoak desaktibatu egingo dira kontuan.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Zure posta-bezeroan, gehitu {senderEmail} zure kontaktuen zerrendara. Honek zure posta-hornitzaileari adierazten dio helbide honetatik bidalitako mezuak fidagarriak izan direla.",
    "Invalid email address": "ePosta helbide baliogabea",
    "Invalid verification code": "",
    "Jamie Larson": "Lur Axpe",
    "jamie@example.com": "lur.axpe@ni.eus",
    "Less like this": "Honelako gutxiago",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Egiaztatu ePostak ez daudela posta baztergarrien edo promozioen karpetetan. Egonez gero, klikatu  \"Ez da mezu baztergarria\" edota \"Mugitu postontzi nagusira\".",
    "Manage": "Kudeatu",
    "Maybe later": "Geroago agian",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "ePosta hornitzaile honetako bazkidetzak mugatuta daude.",
    "Memberships unavailable, contact the owner for access.": "Bazkidetzak ez daude eskuragarri, jarri jabearekin harremanetan sarbidea eskuratzeko.",
    "month": "hilabetea",
    "Monthly": "Hilabetero",
    "More like this": "Honelako gehiago",
    "More options": "",
    "Name": "Izena",
    "Need more help? Contact support": "Laguntza gehiago behar al duzu? Jarri harremanetan",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Zure kontuan buletinak desgaitzeko bi arrazoi daude: aurreko mezuetako bat baztergarritzat jo izana, edo ePosta bideltzean etengabeko hutsegitea (bounce).",
    "No member exists with this e-mail address.": "Ez dago ePosta helbide hau duen kiderik.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ez duzu ePostarik jasotzen?",
    "Now": "",
    "Now check your email!": "Arakatu orain zure ePosta!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Berriro harpidetuz gero, eta, hala ere, postontzian ePostarik ikusten ez baduzu, arakatu posta baztergarriaren karpeta. Hornitzaile batzuek iraganeko arau-hausleen erregistroak daramatzate eta ePosta batzuk mugatzen dituzte. Hau gertatuko balitzaizu, markatu azken buletina 'ez baztergarritzat' postontzi nagusira eramateko.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Etengabeko hutsegitea (bounce)",
    "Phone number": "Telefono zenbakia",
    "Plan": "Plana",
    "Plan checkout was cancelled.": "Planaren ordainketa ezeztatu da.",
    "Plan upgrade was cancelled.": "Planaren aldaketa ezeztatu da.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Jarri harremanetan {supportAddress} zure harpidetza osagarria moldatzeko.",
    "Please enter {fieldName}": "Sartu {fieldName}",
    "Please fill in required fields": "Bete derrigorrezko eremuak",
    "Podcasts": "",
    "Re-enable emails": "Gaitu berriro ePostak",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Gomendioak",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "{price}(r)en truke berrituko da.",
    "Resume subscription": "",
    "Retry": "Saiatu berriro",
    "Save": "Gorde",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Saioa hasteko esteka bidaltzen…",
    "Sending...": "Bidaltzen…",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Erakutsi guztia",
    "Sign in": "Hasi saioa",
    "Sign out": "Amaitu saioa",
    "Sign up": "Eman izena",
    "Signup error: Invalid link": "Errorea izen-ematean: Esteka baliogabea",
    "Signups from this email domain are currently restricted.": "ePosta hornitzaile honetako izen-emateak mugatuta daude.",
    "Something went wrong, please try again later.": "Zerbaitek huts egin du, saiatu berriro geroago.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Une honetan ez dago gomendiorik zuretzat.",
    "Sorry, that didn’t work.": "Kale egin du.",
    "Spam complaints": "ePosta baztergarritzat jota",
    "Start {amount}-day free trial": "Hasi {amount} eguneko probaldia",
    "Starting {startDate}": "{startDate}(e)an hasiko da",
    "Starting today": "Gaur hasiko da",
    "Submit feedback": "Bidali iritzia",
    "Subscribe": "Harpidetu",
    "Subscribed": "Harpidetuta",
    "Subscription plan updated successfully": "Harpidetza-plana eguneratu da",
    "Success": "Primeran",
    "Success! Check your email for magic link to sign-in.": "Primeran! Arakatu zure ePosta esteka magiko baten bila saioa hasteko.",
    "Success! Your account is fully activated, you now have access to all content.": "Primeran! Zure kontua guztiz aktibatu da, eduki guztira duzu sarbidea orain.",
    "Success! Your email is updated.": "Primeran! Zure ePosta eguneratu da.",
    "Successfully unsubscribed": "Harpidetza ezeztatu da",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Eskerrik asko harpidetzeagatik. Irakurtzen hasi aurretik, hona hemen gogoko izan ditzakezun zenbait gune.",
    "Thank you for your support": "Eskerrik asko zure babesagatik",
    "Thank you for your support!": "Eskerrik asko zure babesagatik!",
    "Thanks for the feedback!": "Eskerrik asko iritzia partekatzeagatik!",
    "That didn't go to plan": "Horrek kale egin du",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Gure fitxategian dugun zure ePosta helbidea {memberEmail} da — zuzena ez bada, eguneratu dezakezu zure <button>kontuaren ezarpenen eremuan</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Arazo bat egon da zure iritzia bidaltzean. Saiatu berriro apur bat geroago.",
    "There was an error cancelling your subscription, please try again.": "Errore bat egon da zure harpidetza ezeztatzean, saiatu berriro.",
    "There was an error continuing your subscription, please try again.": "Errore bat egon da harpidetza berritzean, saiatu berriro.",
    "There was an error processing your payment. Please try again.": "Errore bat egon da ordainketa prozesatzean, saiatu berriro.",
    "There was an error sending the email, please try again": "Errore bat egon da ePosta bidaltzean, saiatu berriro.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Gune hau gonbidatuentzat bakarrik da, jarri harremanetan jabearekin sarbidea eskuratzeko.",
    "This site is not accepting donations at the moment.": "Gune honek ez du une honetan dohaintzarik onartzen.",
    "This site is not accepting payments at the moment.": "Gune honek ez du une honetan ordainketarik onartzen.",
    "This site only accepts paid members.": "Gune honek ordainpeko kideak bakarrik onartzen ditu.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Izen-ematea burutzeko, klikatu zure postontziko egiaztatze-esteka. Hiru minututan ailegatzen ez bada, arakatu mezu baztergarrien karpeta.",
    "To continue to stay up to date, subscribe to {publication} below.": "Egunean egoten jarraitu nahi baduzu, harpidetu {publication}(e)ra.",
    "Too many attempts try again in {number} days.": "Saiakera gehiegi; saiatu berriro {number} egun barru.",
    "Too many attempts try again in {number} hours.": "Saiakera gehiegi; saiatu berriro {number} ordu barru.",
    "Too many attempts try again in {number} minutes.": "Saiakera gehiegi; saiatu berriro {number} minutu barru.",
    "Too many different sign-in attempts, try again in {number} days": "Saiakera desberdin gehiegi; saiatu berriro {number} egun barru.",
    "Too many different sign-in attempts, try again in {number} hours": "Saiakera desberdin gehiegi; saiatu berriro {number} ordu barru.",
    "Too many different sign-in attempts, try again in {number} minutes": "Saiakera desberdin gehiegi; saiatu berriro {number} minutu barru.",
    "Too many sign-up attempts, try again later": "Saiakera gehiegi; saiatu berriro geroago",
    "Try free for {amount} days, then {originalPrice}.": "Probatu debalde {amount} egunez, gero {originalPrice}.",
    "Unable to initiate checkout session": "Ezin izan da ordainketa saioa abiarazi",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Ireki sarbidea buletin guztiei ordainpeko harpidedun bilakatzen.",
    "Unsubscribe from all emails": "Ezeztatu ePosta guztietako harpidetza",
    "Unsubscribed": "Harpidetza ezeztatu da",
    "Unsubscribed from all emails.": "Harpidetza ePosta guztietarako ezeztatu da.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "ePosta guztien harpidetza uzteak ez du {title}(e)ko ordainpeko harpidetza ezeztatuko.",
    "Update": "Eguneratu",
    "Update your preferences": "Eguneratu zure hobespenak",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Egiaztatze-esteka bidali zaizu; arakatu postontzia",
    "Verify your email address is correct": "Egiaztatu zure ePosta helbidea zuzena dela",
    "Verifying...": "",
    "View plans": "Ikusi aukeratzeko moduan dauden planak",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Ezin izan dugu zure harpidetza ezeztatu, ez dugulako ePosta helbidea topatu. Jarri harremanetan guneko jabearekin.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Ongi etorri, {name}!",
    "Welcome back!": "Ongi etorri!",
    "Welcome to {siteTitle}": "Ongi etorri {siteTitle}(e)ra",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "",
    "Why has my email been disabled?": "Zergatik ezgaitu da nire ePosta?",
    "X (Twitter)": "",
    "year": "urtea",
    "Yearly": "Urtero",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Une honetan doako bazkidetza duzu; ordaindu sarbide osoa izateko.",
    "You have been successfully resubscribed": "Berriro harpidetu zara",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Une honetan ez zara ePostarik jasotzen ari",
    "You're not receiving emails": "Ez zara ePostarik jasotzen ari",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ez zara ePostarik jasotzen ari, mezuetako bat baztergarritzat jo duzulako edo ezin izan delako emandako ePosta helbidera bidali.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Saioa hasi duzu.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Honakora harpidetu zara: <strong>{siteTitle}</strong>",
    "Your account": "Zure kontua",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Ezin izan da zure ePosta berriro harpidetu, saiatu berriro",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Zure ekarpenak argitaratzen denari forma ematen laguntzen digu.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Zure harpidetza {expiryDate}(e)an iraungiko da",
    "Your subscription will renew on {renewalDate}": "Zure harpidetza {renewalDate}(e)an berrituko da",
    "Your subscription will start on {subscriptionStart}": "Zure harpidetza {subscriptionStart}(e)an hasiko da"
}
